import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import PropTypes from 'prop-types';
import NavBar from '../components/NavBar';

const HomeLayout = ({ children, ...params }) => (
  <main role="main" className="root-container">
    <header className="nav-container">
      <NavBar {...params} />
    </header>
    <section className="main-container">
      <Scrollbars autoHide>{children}</Scrollbars>
    </section>
  </main>
);

HomeLayout.propTypes = {
  children: PropTypes.node,
};

export default HomeLayout;
